import type { ChainModifiers, Entry, EntryFieldTypes, EntrySkeletonType, LocaleCode } from 'contentful';
import type { TypeScrolljackItemSkeleton } from './TypeScrolljackItem';

export interface TypeBlockScrolljackSectionFields {
    internalName: EntryFieldTypes.Symbol;
    overline?: EntryFieldTypes.Symbol;
    headerText?: EntryFieldTypes.Text;
    paragraph?: EntryFieldTypes.Text;
    items: EntryFieldTypes.Array<EntryFieldTypes.EntryLink<TypeScrolljackItemSkeleton>>;
}

export type TypeBlockScrolljackSectionSkeleton = EntrySkeletonType<
    TypeBlockScrolljackSectionFields,
    'blockScrolljackSection'
>;
export type TypeBlockScrolljackSection<
    Modifiers extends ChainModifiers,
    Locales extends LocaleCode = LocaleCode,
> = Entry<TypeBlockScrolljackSectionSkeleton, Modifiers, Locales>;

export function isTypeBlockScrolljackSection<Modifiers extends ChainModifiers, Locales extends LocaleCode>(
    entry: Entry<EntrySkeletonType, Modifiers, Locales>
): entry is TypeBlockScrolljackSection<Modifiers, Locales> {
    return entry.sys.contentType.sys.id === 'blockScrolljackSection';
}
